import axios from "axios";
import { createStore } from "vuex";
import { router } from "../router";

export default createStore({
  state: {
    user: null,
    account: null,
    settings: null,
    currentTime: null,
    routeKey: 0,
    expiration_message: false,
    warning_message: {
      visible: false,
      message: "",
    },
    expired: false,
    connected: true,
  },
  mutations: {
    user(state, user) {
      state.user = user;
    },
    account(state, account) {
      state.account = account;
    },
    settings(state, settings) {
      state.settings = settings;
    },
    tempAccount(state, tempAccount) {
      state.tempAccount = tempAccount;
    },
    currentTime(state, currentTime) {
      state.currentTime = currentTime;
    },
    changeKey(state) {
      state.routeKey++;
    },
    show_expiration_message(state, value) {
      state.expiration_message = value;
    },
    show_warning_message(state, value) {
      state.warning_message.visible = value;
    },
    set_warning_message(state, value) {
      state.warning_message.message = value;
    },
    set_expired(state, value) {
      state.expired = value;
    },
    fetch_user(state, value) {
      state.user = value;
    },
    fetch_account(state, value) {
      state.account = value;
    },
  },
  actions: {
    user(context, user) {
      context.commit("user", user);
    },
    settings(context, settings) {
      context.commit("settings", settings);
    },
    currentTime(context, currentTime) {
      context.commit("currentTime", currentTime);
    },
    changeKey(context) {
      context.commit("routeKey");
    },
    show_expiration_message(context, value) {
      context.commit("show_expiration_message", value);
    },
    show_warning_message(context, value) {
      context.commit("show_warning_message", value);
    },
    set_warning_message(context, value) {
      context.commit("set_warning_message", value);
    },
    set_expired(context, value) {
      context.commit("set_expired", value);
    },
    async fetch_user(context) {
      try {
        if (window.location.hostname != "localhostt") {
          const response = await axios.get("user");
          if (response.status == 200) {
            context.commit("fetch_user", response.data.data);
          }
          const response2 = await axios.get("settings");
          if (response2.status == 200) {
            context.commit("settings", response2.data.data);
          }
        } else {
          context.commit("fetch_user", {
            id: 1,
            name: "Admin",
            email: "admin@ssradius",
            money: 100,
            benefit_rate: 30,
            realm: "864000",
            type: "sysadmin",
            privileges: [],
          });
          context.commit("settings", {
            network_name: "ALNOUR",
            network_logo:
              "system_images/oqyGfle090NVoHbF4Xrp5YSws1SeqerELq0Nff0B.png",
            currency: "\u20ba",
            language: "ar",
            time_zone: "Europe/Istanbul",
            mikrotik_auto_reboot: "1",
            default_expiration_hour: "12",
            ssr_account_password_change: "1",
            ssr_account_profile_update: "1",
            center: "0",
            auto_backup: "true",
            expiration_profile_message:
              "\u0644\u0642\u062f \u0627\u0646\u062a\u0647\u0649 \u0627\u0634\u062a\u0631\u0627\u0643\u0643 \u0641\u064a \u0634\u0628\u0643\u062a\u0646\u0627 \u064a\u0631\u062c\u0649 \u0645\u0631\u0627\u062c\u0639\u0629 \u0645\u0631\u0643\u0632 \u0627\u0644\u0634\u0628\u0643\u0629 \u0644\u062a\u0641\u0639\u064a\u0644 \u0627\u0644\u0627\u0634\u062a\u0631\u0627\u0643",
            phone_number: "+905355036892",
            status_url: "n.net",
            nas_interim_update: "5m",
            wa_token: null,
            wa_instance: null,
            features: {
              admins: true,
              resellers: true,
              dma_import: true,
              mikrotik_services: true,
              open_profile: true,
              backups: true,
              ssra: true,
              port_forward: true,
              wa: true,
            },
            license: {
              serial_number: "864440",
              realm: "864212",
              expires_at: "2025-12-26",
              package: "full_wa",
              online_count: 500,
              nases_count: 12,
              admins_count: 12,
              resellers_count: 12,
              active: true,
              features: 511,
              updated_at: "2024-12-29T18:29:03.000000Z",
              created_at: "2022-05-12T21:46:37.000000Z",
            },
            sessions: {
              online: 292,
              available: 500,
              remaining: 208,
            },
            ssr_auth_connected: true,
            type: "online",
            version: "0",
            update_name: "v1.49",
            benefit_rate: "30",
            created_at: "2022-05-12T21:46:37.000000Z",
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetch_account(context) {
      try {
        const account_username =
          localStorage.getItem("account_username") || true;
        const account_password =
          localStorage.getItem("account_password") || true;
        const account_realm = localStorage.getItem("account_realm") || true;
        if (account_username && account_password && account_realm) {
          context.commit("fetch_account", {
            username: account_username,
            password: account_password,
            realm: account_realm,
            profile: {
              name: "DF1",
            },
          });
          context.commit("settings", {
            currency: "$",
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  modules: {},
  getters: {
    user: (state) => {
      return state.user;
    },
    settings: (state) => {
      return state.settings;
    },
    tempAccount: (state) => {
      return state.tempAccount;
    },
    currentTime: (state) => {
      return state.currentTime;
    },
    routeKey: (state) => {
      return state.routeKey;
    },
    expiration_message: (state) => {
      return state.expiration_message;
    },
    warning_message: (state) => {
      return state.warning_message;
    },
    expired: (state) => {
      return state.expired;
    },
  },
});
